import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import { ModalContext } from '../components/globals/ModalContext'

const withGlobalModal = (WrappedComponent) => {
  class ModalContainerConsumer extends React.PureComponent {
    render () {
      return (
        <ModalContext.Consumer>
          {(modalProps) => (
            <WrappedComponent {...this.props} {...modalProps} />
          )}
        </ModalContext.Consumer>
      )
    }
  }

  return hoistNonReactStatics(ModalContainerConsumer, WrappedComponent)
}

export default withGlobalModal
